import { Injectable } from '@angular/core';

export interface IPromiseAggregator {
	aggregate(promises: Promise<any>[], callback: () => void): void;
}

@Injectable({
	providedIn: 'root',
})
export class PromiseAggregator implements IPromiseAggregator {
	aggregate(promises: Promise<any>[], callback: () => void): void {
		Promise.allSettled(promises).then(() => {
			callback();
		});
	}
}

export class MockPromiseAggregator implements IPromiseAggregator {
	aggregate(_: Promise<any>[], callback: () => void): void {
		callback();
	}
}
